import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './InfoCard.styles'

interface InfoCardProps {
  title: string
  description: string
  children: React.ReactNode
}

const InfoCard = ({ title, description, children }: InfoCardProps) => {
  const classes = useStyles()
  return (
    <Box className={classes.card}>
      <Typography variant="h4" className={classes.cardTitle}>
        {title}
      </Typography>
      <Typography className={classes.cardText}>{description}</Typography>
      <Box className={classes.buttonContainer}>{children}</Box>
    </Box>
  )
}

export default InfoCard
